"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _properties = _interopRequireDefault(require("./properties"));

var ignoreProps = ['triggerSlideEvent', 'triggerChangeEvent', 'debounce'];
var watchers = {
  disabled: function disabled(value) {
    if (value) {
      this.slider.disable();
    } else {
      this.slider.enable();
    }
  },
  value: function value(_value) {
    this.slider.setValue(_value, this.triggerSlideEvent, this.triggerChangeEvent);
  }
};
Object.keys(_properties.default).forEach(function (prop) {
  if (!watchers[prop] && !ignoreProps.includes(prop)) {
    watchers[prop] = function (value, oldValue) {
      if (this.slider && value !== oldValue) {
        this.slider.setAttribute(prop, value);
        this.refresh();
      }
    };
  }
});
var _default = watchers;
exports.default = _default;